import React from "react";

import { usePopup } from "hooks";
import { makeBEM } from "utils";

import { Card } from "../card";

import "./index.scss";

export interface DropdownProps {
  open?: boolean;
  onClose?: () => void;
  modifiers?: Modifiers;
  dropdownContent: React.ReactNode;
}

export type Modifiers = "right" | "left";

const bem = makeBEM("dropdown");

const DropdownContent = ({ onClose, dropdownContent, modifiers = "right" }: Omit<DropdownProps, "open">) => {
  React.useEffect(() => {
    const closeOverlay = () => onClose?.();

    document.addEventListener("click", closeOverlay);
    return () => document.removeEventListener("click", closeOverlay);
  }, [onClose]);

  return <Card className={bem("content", [modifiers])}>{dropdownContent}</Card>;
};

export const Dropdown: React.FC<React.PropsWithChildren<DropdownProps>> = ({ children, open, ...props }) => {
  usePopup(!!open);

  return (
    <div className={bem(null, { open })}>
      {children}
      {open && <DropdownContent {...props} />}
    </div>
  );
};
